import Dashboard from "../component/Pages/Dashboard/DashboardView/Dashboard";
import Learner from "../component/Pages/Learner/ViewLearner/Learner";
import AddLearner from "../component/Pages/Learner/AddLearner/AddLearner";
import EditLearner from "../component/Pages/Learner/EditLearner/EditLearner";
import AssignLearner from "../component/Pages/Learner/AssignLearner/AssignLearner";
import Exam from "../component/Pages/Exam/ViewExam/Exam";
import AddExam from "../component/Pages/Exam/AddExam/AddExam";
import EditExam from "../component/Pages/Exam/EditExam/EditExam";
import ExamDashboard from "../component/Pages/Exam/ExamDashboard/ExamDashboard";
import ExamResult from "../component/Pages/Exam/ExamResult/ExamResult";
import AddQuestionMain from "../component/Pages/Exam/AddQuestion/AddQuestionMain";
import AddMarksMain from "../component/Pages/Exam/AddMarks/AddMarksMain";
import ActivityLogs from "../component/Pages/Exam/ActivityLogs/ActivityLogs";

const BasicSixMonths = [
  {
    id: "activitylogs",
    path: "/admin/activitylogs/:rowId",
    element: <ActivityLogs />,
  },
  {
    id: "dashboard",
    path: "/admin/dashboard",
    element: <Dashboard />,
  },
  {
    id: "learner",
    path: "/admin/learner",
    element: <Learner />,
  },
  {
    id: "addlearner",
    path: "/admin/addlearner",
    element: <AddLearner />,
  },
  {
    id: "editlearners",
    path: "/admin/editlearners/:rowId",
    element: <EditLearner />,
  },
  {
    id: "assignlearner",
    path: "/admin/assignlearner",
    element: <AssignLearner />,
  },
  {
    id: "assignlearner_2",
    path: "/admin/assignlearner/:selectedCource1/:selectedBatch1/:selectedCenter1",
    element: <AssignLearner />,
  },
  {
    id: "exam",
    path: "/admin/exam",
    element: <Exam />,
  },
  {
    id: "addexam",
    path: "/admin/addexam",
    element: <AddExam />,
  },
  {
    id: "editexam",
    path: "/admin/editexam/:rowId",
    element: <EditExam />,
  },
  {
    id: "examdashboard",
    path: "/admin/examdashboard/:rowId",
    element: <ExamDashboard />,
  },
  {
    id: "examresult",
    path: "/admin/examresult/:rowId",
    element: <ExamResult />,
  },
  {
    id: "addquestion",
    path: "/admin/addquestion/:rowId",
    element: <AddQuestionMain />,
  },
  {
    id: "addmarks",
    path: "/admin/addmarks/:rowId",
    element: <AddMarksMain />,
  },
];

export default BasicSixMonths;
